module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer left-1-md"
  }, [_c('div', {
    staticClass: "row footer__links"
  }, [_c('router-link', {
    staticClass: "col-2 footer__link",
    attrs: {
      "to": _vm.prev
    }
  }, [_vm._v("Prev")]), _vm._v(" "), _c('router-link', {
    staticClass: "col-2 left-2 left-0-md footer__link",
    attrs: {
      "to": _vm.next
    }
  }, [_vm._v("Next")])], 1), _vm._v(" "), _c('span', {
    staticClass: "footer__copy"
  }, [_vm._v("© " + _vm._s(_vm.year) + " Thank Your For Clapping")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-843b16cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/work/Footer.vue
// module id = 394
// module chunks = 2